import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import FormElement from '~/components/FormElement';
export default {
  name: "AnswerComponent",
  components: {
    FormElement: FormElement
  },
  props: {
    token: {
      type: String,
      default: null
    },
    reorder: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: null
    },
    uuid: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: undefined
    },
    stepInfos: {
      type: Object,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    screeningUuid: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      blockToDel: null,
      displayConfirmation: false,
      activeErrors: [],
      isReadonly: this.value.readonly || this.readonly
    };
  },
  watch: {
    "value.data": {
      deep: true,
      handler: function handler() {
        this.value.updated_at = new Date().toISOString();
      }
    },
    activeErrors: {
      deep: true,
      handler: function handler(newErrors) {
        var arrayErrors = Object.values(newErrors);
        var nbErrors = arrayErrors.filter(function (field) {
          return field.length > 0;
        }).length;
        var id = this.uuid;
        if (nbErrors > 0) {
          this.$store.commit("screeningsErrors/ADD_LIST", {
            id: id,
            text: this.$tc("pages.screenings.stepErrorMessage", nbErrors, {
              countError: nbErrors
            })
          });
        } else {
          this.$store.commit("screeningsErrors/REMOVE_LIST", {
            id: id
          });
        }
        this.$emit("dump-validate");
      }
    }
  },
  created: function created() {
    if (this.value.isValid === undefined) {
      this.$set(this.value, "isValid", false);
    }
    if (this.reorder && !!this.$helpers && !!this.$helpers.sortElements) {
      this.stepInfos.form_elements = this.$helpers.sortElements(this.stepInfos.form_elements, function (a, b) {
        return a[1].order - b[1].order;
      });
    }
  },
  mounted: function mounted() {
    this.observerWatch();
  },
  methods: {
    observerWatch: function observerWatch() {
      var _this = this;
      this.$watch(function () {
        var _this$$refs$observer;
        return (_this$$refs$observer = _this.$refs.observer) === null || _this$$refs$observer === void 0 ? void 0 : _this$$refs$observer.errors;
      }, function (val) {
        _this.activeErrors = val;
      });
    },
    confirmDel: function confirmDel(blockName, index, ref) {
      this.blockToDel = {
        blockName: blockName,
        index: index,
        ref: ref
      };
      this.displayConfirmation = true;
    },
    closeConfirm: function closeConfirm() {
      this.blockToDel = null;
      this.displayConfirmation = false;
    },
    addBlock: function addBlock(blockName, ref) {
      var _this2 = this;
      if (!this.isReadonly) {
        var formElements = Object.fromEntries(Object.keys(this.stepInfos.form_elements[blockName].block_content).map(function (key) {
          return [[key], {
            answer: null,
            locked: false
          }];
        }));
        this.value.data[blockName].push(formElements);
        var domOldBlock = this.$refs[ref][0];
        if (!!domOldBlock) {
          var _document$querySelect;
          var headerHeight = ((_document$querySelect = document.querySelector("header")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
          var offset = -domOldBlock.$el.clientHeight + headerHeight;
          setTimeout(function () {
            _this2.$vuetify.goTo(domOldBlock, {
              offset: offset
            });
          }, 500);
        }
        this.$store.dispatch("flashMessages/messageSuccess", {
          message: this.$i18n.t("messages.action_addBlock_confirmed")
        }, {
          root: true
        });
      }
    },
    formElementsWithValue: function formElementsWithValue(value, key, blockIndex, subKey) {
      try {
        return !!value.data[key][blockIndex][subKey];
      } catch (e) {
        return false;
      }
    },
    delBlock: function delBlock() {
      this.value.data[this.blockToDel.blockName].splice(this.blockToDel.index, 1);
      this.closeConfirm();
      this.$store.dispatch("flashMessages/messageSuccess", {
        message: this.$i18n.t("messages.action_delBlock_confirmed")
      }, {
        root: true
      });
      this.$emit("scroll-to", {
        uuid: this.uuid
      });
    },
    isDisplayed: function isDisplayed(question, name, blockIndex) {
      var _question$display,
        _question$display2,
        _this3 = this,
        _question$display3;
      var equal = function equal(a, b) {
        return a === b;
      };
      var getAgeLtLimit = function getAgeLtLimit(condition) {
        if (_typeof(condition) !== "string") {
          return null;
        }
        var match = condition.match(/^__age_lt__:(\d+)$/);
        if (!match) {
          return null;
        }
        var limit = Number.parseInt(match[1], 10);
        return Number.isNaN(limit) ? null : limit;
      };
      var getAgeInYears = function getAgeInYears(value) {
        if (_typeof(value) !== "string" || value.length === 0) {
          return null;
        }
        var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) {
          return null;
        }
        var year = Number.parseInt(match[1], 10);
        var month = Number.parseInt(match[2], 10);
        var day = Number.parseInt(match[3], 10);
        var parsed = new Date(year, month - 1, day);
        if (parsed.getFullYear() !== year || parsed.getMonth() + 1 !== month || parsed.getDate() !== day) {
          return null;
        }
        var now = new Date();
        var age = now.getFullYear() - year;
        var nowMonth = now.getMonth() + 1;
        var nowDay = now.getDate();
        if (nowMonth < month || nowMonth === month && nowDay < day) {
          age -= 1;
        }
        return age;
      };
      var isAgeLtConditionSatisfied = function isAgeLtConditionSatisfied(condition, answer) {
        var limit = getAgeLtLimit(condition);
        if (limit === null) {
          return false;
        }
        if (Array.isArray(answer)) {
          return answer.some(function (item) {
            var age = getAgeInYears(item);
            return age !== null && age < limit;
          });
        }
        var age = getAgeInYears(answer);
        return age !== null && age < limit;
      };
      if (!question.display || !!(question !== null && question !== void 0 && (_question$display = question.display) !== null && _question$display !== void 0 && _question$display.displayed)) {
        return true;
      }
      if (!question.display || !!(question !== null && question !== void 0 && (_question$display2 = question.display) !== null && _question$display2 !== void 0 && _question$display2.displayed)) {
        return true;
      }
      var func = function func(key) {
        var _this3$value, _this3$value$data$key;
        var answersCondition = question.display.is_displayed_if[key].answers_condition;
        var answerValue = (_this3$value = _this3.value) === null || _this3$value === void 0 ? void 0 : (_this3$value$data$key = _this3$value.data[key]) === null || _this3$value$data$key === void 0 ? void 0 : _this3$value$data$key.answer;
        if ((Array.isArray(answerValue) && answerValue.length === 0 || answerValue === null) && answersCondition.length === 0) return true;
        // some() because only one match in answers list is enough
        return answersCondition.some(function (value) {
          var _this3$stepInfos, _this3$stepInfos$form, _this3$stepInfos$form2;
          var isSpecialAgeCondition = getAgeLtLimit(value) !== null;
          if (isSpecialAgeCondition) {
            var _test = isAgeLtConditionSatisfied(value, answerValue);
            var _subTest = false;
            if (blockIndex !== undefined && blockIndex !== null && !!_this3.value.data[name] && !!_this3.value.data[name][blockIndex] && !!_this3.value.data[name][blockIndex][key]) {
              var _this3$value$data$nam;
              _subTest = isAgeLtConditionSatisfied(value, (_this3$value$data$nam = _this3.value.data[name][blockIndex][key]) === null || _this3$value$data$nam === void 0 ? void 0 : _this3$value$data$nam.answer);
            }
            return _test || _subTest;
          }
          var comparison = equal;
          // switch (question.display.is_displayed_if[key].comparison) {
          //   // change comparison test
          // }
          var test = Array.isArray(answerValue) ? Array.isArray(value) && value.length === 0 && answerValue.length === 0 ? true : answerValue.some(function (a) {
            return comparison(a, value);
          }) : (_this3 === null || _this3 === void 0 ? void 0 : (_this3$stepInfos = _this3.stepInfos) === null || _this3$stepInfos === void 0 ? void 0 : (_this3$stepInfos$form = _this3$stepInfos.form_elements) === null || _this3$stepInfos$form === void 0 ? void 0 : (_this3$stepInfos$form2 = _this3$stepInfos$form[key]) === null || _this3$stepInfos$form2 === void 0 ? void 0 : _this3$stepInfos$form2.type) === "selection_controls" && Array.isArray(value) && value.length === 0 && answerValue === null ? true : comparison(value, answerValue);
          var subTest = false;
          if (blockIndex !== undefined && blockIndex !== null) {
            if (!!_this3.value.data[name] && !!_this3.value.data[name][blockIndex] && !!_this3.value.data[name][blockIndex][key]) {
              var _this3$value2, _this3$value2$data$na, _this3$value3, _this3$value3$data$na;
              subTest = comparison(value, _this3.value.data[name][blockIndex][key].answer);
              subTest = Array.isArray((_this3$value2 = _this3.value) === null || _this3$value2 === void 0 ? void 0 : (_this3$value2$data$na = _this3$value2.data[name][blockIndex][key]) === null || _this3$value2$data$na === void 0 ? void 0 : _this3$value2$data$na.answer) ? _this3.value.data[name][blockIndex][key].answer.some(function (a) {
                return comparison(a, value);
              }) : comparison(value, (_this3$value3 = _this3.value) === null || _this3$value3 === void 0 ? void 0 : (_this3$value3$data$na = _this3$value3.data[name][blockIndex][key]) === null || _this3$value3$data$na === void 0 ? void 0 : _this3$value3$data$na.answer);
            }
          }
          return test || subTest;
        });
      };
      var any = function any(array) {
        return Object.keys(array).some(func);
      };
      var every = function every(array) {
        return Object.keys(array).every(func);
      };
      var displayComparison = (question === null || question === void 0 ? void 0 : (_question$display3 = question.display) === null || _question$display3 === void 0 ? void 0 : _question$display3.condition_type) === "OR" ? any : every;
      var isDisplayed = false;
      if (!!question.display.is_displayed_if && Object.keys(question.display.is_displayed_if).length > 0) {
        // every() because all condition must be verified
        isDisplayed = displayComparison(question.display.is_displayed_if);
      }
      if (!isDisplayed) {
        var _this$value, _this$value$data$name;
        if (!!((_this$value = this.value) !== null && _this$value !== void 0 && (_this$value$data$name = _this$value.data[name]) !== null && _this$value$data$name !== void 0 && _this$value$data$name.answer)) {
          this.value.data[name].answer = null;
        } else if (blockIndex !== undefined && !!this.value.data[name] && !!this.value.data[name][blockIndex] && !!this.value.data[name][blockIndex][question.title]) {
          this.value.data[name][blockIndex][question.title].answer = null;
        }
      }
      return isDisplayed;
    },
    blurQuestion: function blurQuestion(event) {
      this.stepInfos.updated_at = this.$moment.utc().unix();
      this.$emit("blur-question", event);
      this.$forceUpdate();
    },
    validate: function validate(options) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this4.readonly) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", null);
            case 2:
              _context.next = 4;
              return _this4.$refs.observer.validateWithInfo(options);
            case 4:
              result = _context.sent;
              _this4.value.isValid = result.isValid;
              _this4.$emit("input", _this4.value);
              return _context.abrupt("return", result.errors);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getErrors: function getErrors() {
      return this.$refs.observer.errors;
    },
    setErrors: function setErrors(errors) {
      var _this5 = this;
      if (!!errors) {
        this.$refs.observer.setErrors(errors);
        // Pass errors to block observers
        Object.keys(errors).forEach(function (key) {
          if (!!_this5.stepInfos.form_elements[key] && _this5.stepInfos.form_elements[key].type === "block") {
            errors[key].forEach(function (blockErr, blockKey) {
              var blockName = "observer_block_".concat(key, "_").concat(blockKey);
              if (!!_this5.$refs[blockName]) {
                var blockObserver = _this5.$refs[blockName][0] || _this5.$refs[blockName];
                blockObserver.setErrors(blockErr);
              }
            });
          }
        });
        this.value.isValid = !Object.keys(errors).some(function (key) {
          return errors[key].length > 0;
        });
        this.$emit("input", this.value);
      }
    }
  }
};